var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { keyBy, xor } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { CurrencyCode } from '../../../enum';
import { RumEntityLabel } from '../../../observability/rumEntity';
import { ErrorMessageBox, FallbackComponent } from '../../common';
import { stringToNumber } from '../../common/numberInput/hooks';
import { FormlessProvider } from '../../hooks/useFormlessContext';
import { useForbiddenRedirect, useReportAPI } from '../../report/selectors';
import { useToastMessagesAPI } from '../../toastify/selector';
import { LocationTableEntryMode } from '../../wizard/constants';
import { pickNumberValues, selectShrinkageValues, selectSupportStaffValues } from '../../wizard/useDefaultValue';
import { WizardSimpleProvider } from '../../wizard/useWizardSimpleContext';
import { generateValidateField, getStaffValidation, rolesSchema, shrinkageShape } from '../../wizard/validateForm';
import { Actions } from '../actions';
import { commonFootprint, useMultiSkillParams, useQueueByIds } from '../selectors';
import { MultiSkillStep } from '../types';
import { MultiSkillGroupDetail } from './multiSkillGroupDetail';
import { MultiSkillGroups } from './multiSkillGroups';
import { MultiskillLocationsProvider } from './multiskillLocationsContext';
import { useGroupDetailAPI, useMultiSkillAPI, useSimulationAPI } from './selectors';
export var shouldFillFromAverage = function (group) { var _a; return !((_a = group.shrinkages) === null || _a === void 0 ? void 0 : _a.length) && (!group.id || !!xor(group._children, group.children).length); };
var buildRolePayload = function (role, includeId) { return (__assign(__assign({}, (includeId && role.id != null ? { id: role.id } : {})), { role: role.role, ratio: role.ratio, salary: role.salary, staffCalculate: role.staffCalculate, roleAppliesTo: role.roleAppliesTo, wageType: role.wageType, loadFactor: role.loadFactor })); };
var buildShrinkagePayload = function (shrinkage, includeId) { return (__assign(__assign({}, (includeId && shrinkage.id != null ? { id: shrinkage.id } : {})), { month: shrinkage.month, name: shrinkage.name, percent: shrinkage.percent, shrinkageCategory: shrinkage.shrinkageCategory, shrinkageSubcategory: shrinkage.shrinkageSubcategory, shrinkageType: shrinkage.shrinkageType })); };
var buildVolumePayload = function (volume) { return ({
    rate: volume.rate,
    attrition: volume.attrition,
}); };
export var buildMultiskillPayload = function (item) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var locations = ((_a = item.queueLocations) === null || _a === void 0 ? void 0 : _a.length) ? item.queueLocations : (_b = item.locations) !== null && _b !== void 0 ? _b : [];
    var hasLocations = locations.length > 0;
    var flatShrinkages = ((_d = (_c = item.shrinkages) === null || _c === void 0 ? void 0 : _c.flat()) !== null && _d !== void 0 ? _d : []).filter(function (shrinkage) { return (shrinkage === null || shrinkage === void 0 ? void 0 : shrinkage.month) != null && typeof shrinkage.name === 'string' && shrinkage.name.length; });
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (item.id == null ? {} : { id: item.id })), { businessArea: item.businessArea, children: item.children }), (item.multiplier == null ? {} : { multiplier: Number(item.multiplier) })), (item.trainWeeks == null ? {} : { trainWeeks: Number(item.trainWeeks) })), { maxOccupancy: item.maxOccupancy == null || item.maxOccupancy === '' ? null : Number(item.maxOccupancy) }), (item.multiskillType == null ? {} : { multiskillType: Number(item.multiskillType) })), (item.isUseWAP == null ? {} : { isUseWAP: Number(item.isUseWAP) })), { attritionEntryMode: shouldFillFromAverage(item)
            ? null
            : (_g = (_e = item.attritionEntryMode) !== null && _e !== void 0 ? _e : (_f = item._raw) === null || _f === void 0 ? void 0 : _f.attritionEntryMode) !== null && _g !== void 0 ? _g : LocationTableEntryMode.Percentage }), (hasLocations
        ? {
            queueLocations: locations.map(function (location) {
                var _a, _b, _c;
                return (__assign(__assign(__assign({ planLocationId: (_a = location.planLocation) === null || _a === void 0 ? void 0 : _a.id, currencyCode: location.currencyCode }, (location.multiplier == null ? {} : { multiplier: Number(location.multiplier) })), (location.trainWeeks == null ? {} : { trainWeeks: Number(location.trainWeeks) })), { roles: ((_b = location.roles) !== null && _b !== void 0 ? _b : []).map(function (role) { return buildRolePayload(role, false); }), shrinkages: flatShrinkages
                        .filter(function (shrinkage) { return shrinkage.queueLocationId === location.id; })
                        .map(function (shrinkage) { return buildShrinkagePayload(shrinkage, false); }), volumes: ((_c = location.volumes) !== null && _c !== void 0 ? _c : []).map(function (volume) { return buildVolumePayload(volume); }) }));
            }),
        }
        : __assign(__assign({}, (((_h = item.roles) === null || _h === void 0 ? void 0 : _h.length) ? { roles: item.roles.map(function (role) { return buildRolePayload(role, true); }) } : {})), { volumes: ((_j = item.volumes) !== null && _j !== void 0 ? _j : []).map(function (volume) { return buildVolumePayload(volume); }), shrinkages: flatShrinkages
                .filter(function (shrinkage) { return shrinkage.queueLocationId == null; })
                .map(function (shrinkage) { return buildShrinkagePayload(shrinkage, true); }) }))), { currencyCode: item.sourceCurrencyCode });
};
export var MultiSkillGroup = function (_a) {
    var _b, _c, _d, _e;
    var multiSkillGroups = _a.multiSkillGroups, setMultiSkillGroups = _a.setMultiSkillGroups, goToStep = _a.goToStep, permission = _a.permission, onCurrenciesChange = _a.onCurrenciesChange;
    var _f = useState(0), activeGroup = _f[0], setActiveGroup = _f[1];
    var defaultValues = useMemo(function () { return multiSkillGroups[activeGroup]; }, [activeGroup, multiSkillGroups]);
    var planData = useReportAPI()[0];
    var _g = useGroupDetailAPI(multiSkillGroups[activeGroup]), queueData = _g[0], fetchQueueData = _g[1], clearQueueData = _g[2];
    var _h = useMultiSkillAPI(), multiskillData = _h[0], fetchMultiskillData = _h[1], clearMultiskillData = _h[2];
    var _j = useSimulationAPI(), simulationData = _j[0], fetchSimulationData = _j[1], clearSimulationData = _j[2];
    var _k = useToastMessagesAPI(), fetchToastMessagesData = _k[1];
    useForbiddenRedirect([multiskillData.statusCode]);
    var basePlanId = useMultiSkillParams().basePlanId;
    var navigate = useNavigate();
    // Form depends on the active group's members only; sibling groups must not leak in.
    var activeMemberIds = useMemo(function () { var _a, _b; return Array.from(new Set((_b = (_a = multiSkillGroups[activeGroup]) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [])); }, [activeGroup, multiSkillGroups]);
    var activeMemberQueues = useQueueByIds(activeMemberIds);
    var activeMemberQueueMap = useMemo(function () { return keyBy(activeMemberQueues, 'id'); }, [activeMemberQueues]);
    // Whole-plan member map, for submit-time validation of every group.
    var allMemberIds = useMemo(function () { return Array.from(new Set(multiSkillGroups.flatMap(function (group) { return group.children; }))); }, [multiSkillGroups]);
    var allMemberQueues = useQueueByIds(allMemberIds);
    var allMemberQueueMap = useMemo(function () { return keyBy(allMemberQueues, 'id'); }, [allMemberQueues]);
    // Location-aware form: one entry per common member location; per-location values are editable.
    var hasGroupLocations = useMemo(function () {
        return commonFootprint(activeMemberIds.map(function (id) { return activeMemberQueueMap[id]; }).filter(Boolean)).commonLocations.length > 0;
    }, [activeMemberIds, activeMemberQueueMap]);
    // No own learning-curve inputs: Absolute entry requires every member at LC=100.
    var allMembersLearningCurve100 = useMemo(function () {
        return activeMemberIds.length > 0 && activeMemberIds.every(function (id) { var _a; return ((_a = activeMemberQueueMap[id]) === null || _a === void 0 ? void 0 : _a.learningCurve100) === true; });
    }, [activeMemberIds, activeMemberQueueMap]);
    var validateForm = yup.object().shape(__assign(__assign({ maxOccupancy: yup.number().nullable() }, shrinkageShape), (hasGroupLocations
        ? {
            queueLocations: yup
                .array()
                .of(yup.object().shape({
                roles: rolesSchema,
                multiplier: yup.number().required(),
                trainWeeks: yup.number().required(),
                volumes: generateValidateField('rate', 'attrition'),
            }))
                .required(),
        }
        : __assign(__assign({}, getStaffValidation(false)), { volumes: generateValidateField('rate', 'attrition'), multiplier: yup.number().required(), trainWeeks: yup.number().required() }))));
    var methods = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(validateForm),
    });
    var reset = methods.reset, handleSubmit = methods.handleSubmit, control = methods.control, setValue = methods.setValue, getValues = methods.getValues, watch = methods.watch;
    var queue = useWatch({ name: '_raw', control: control });
    var formValues = watch();
    var currentCurrency = useWatch({ name: 'sourceCurrencyCode', control: control });
    var currentQueueLocations = useWatch({ name: 'queueLocations', control: control });
    var currentLocations = useWatch({ name: 'locations', control: control });
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!onCurrenciesChange)
            return;
        var codes = new Set();
        for (var i = 0; i < multiSkillGroups.length; i++) {
            var g = multiSkillGroups[i];
            var locations = i === activeGroup
                ? (_b = (_a = currentQueueLocations !== null && currentQueueLocations !== void 0 ? currentQueueLocations : currentLocations) !== null && _a !== void 0 ? _a : g.locations) !== null && _b !== void 0 ? _b : g.queueLocations
                : (_c = g.locations) !== null && _c !== void 0 ? _c : g.queueLocations;
            var locationCodes = (locations !== null && locations !== void 0 ? locations : []).map(function (ql) { return ql.currencyCode; }).filter(Boolean);
            if (locationCodes.length) {
                for (var _i = 0, locationCodes_1 = locationCodes; _i < locationCodes_1.length; _i++) {
                    var code = locationCodes_1[_i];
                    codes.add(code);
                }
                continue;
            }
            var monoCurrency = i === activeGroup
                ? (_e = (_d = currentCurrency !== null && currentCurrency !== void 0 ? currentCurrency : g.sourceCurrencyCode) !== null && _d !== void 0 ? _d : g.currencyCode) !== null && _e !== void 0 ? _e : CurrencyCode.Dollar
                : (_g = (_f = g.sourceCurrencyCode) !== null && _f !== void 0 ? _f : g.currencyCode) !== null && _g !== void 0 ? _g : CurrencyCode.Dollar;
            if (monoCurrency) {
                codes.add(monoCurrency);
            }
        }
        onCurrenciesChange(Array.from(codes));
    }, [currentCurrency, currentQueueLocations, currentLocations, multiSkillGroups, activeGroup, onCurrenciesChange]);
    var isActionLoading = !!multiskillData.requesting || !!simulationData.requesting;
    useEffect(function () {
        if (!multiSkillGroups.length) {
            goToStep(MultiSkillStep.Add);
        }
    }, [goToStep, multiSkillGroups.length]);
    useEffect(function () {
        fetchQueueData();
        return clearQueueData;
    }, [clearQueueData, fetchQueueData]);
    useEffect(function () {
        if (multiskillData.data) {
            fetchSimulationData();
        }
        return clearMultiskillData;
    }, [clearMultiskillData, fetchSimulationData, multiskillData.data]);
    useEffect(function () {
        if (simulationData.data) {
            navigate("/report/".concat(basePlanId));
            fetchToastMessagesData();
        }
        return clearSimulationData;
    }, [basePlanId, clearSimulationData, fetchToastMessagesData, navigate, simulationData.data]);
    useEffect(function () {
        reset(defaultValues);
    }, [defaultValues, reset]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        var groupData = multiSkillGroups[activeGroup];
        if (queueData.data && groupData) {
            var shrinkages = selectShrinkageValues(queueData.data);
            var supportStaff = selectSupportStaffValues(queueData.data);
            var volumes = queueData.data.volumes.map(function (v) { return pickNumberValues(v, [], 'rate', 'attrition'); });
            // One entry per common member location; only per-location values are editable.
            var commonLocationIds = commonFootprint(activeMemberIds.map(function (id) { return activeMemberQueueMap[id]; }).filter(Boolean)).commonLocations;
            var commonLocationSet_1 = new Set(commonLocationIds);
            var seenPlanLocationIds_1 = new Set();
            var groupLocations = ((_a = queueData.data.queueLocations) !== null && _a !== void 0 ? _a : [])
                .filter(function (loc) {
                var _a, _b;
                var planLocationId = (_b = (_a = loc.planLocation) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : loc.planLocationId;
                if (!commonLocationSet_1.has(planLocationId) || seenPlanLocationIds_1.has(planLocationId))
                    return false;
                seenPlanLocationIds_1.add(planLocationId);
                return true;
            })
                .map(function (loc) {
                var _a, _b, _c, _d;
                return ({
                    id: loc.id,
                    queueId: loc.queueId,
                    planLocation: loc.planLocation,
                    currencyCode: loc.currencyCode,
                    multiplier: Number((_a = loc.multiplier) !== null && _a !== void 0 ? _a : 1),
                    trainWeeks: Number((_b = loc.trainWeeks) !== null && _b !== void 0 ? _b : 0),
                    roles: ((_c = loc.roles) !== null && _c !== void 0 ? _c : []).map(function (role) {
                        return pickNumberValues(role, ['id', 'staffCalculate', 'role', 'roleAppliesTo', 'wageType'], 'ratio', 'salary', 'loadFactor');
                    }),
                    volumes: ((_d = loc.volumes) !== null && _d !== void 0 ? _d : []).map(function (v) { return pickNumberValues(v, [], 'rate', 'attrition'); }),
                });
            });
            var isLocated = groupLocations.length > 0;
            reset(__assign(__assign(__assign(__assign(__assign(__assign({ _raw: queueData.data }, groupData), { attritionEntryMode: (_c = (_b = groupData.attritionEntryMode) !== null && _b !== void 0 ? _b : queueData.data.attritionEntryMode) !== null && _c !== void 0 ? _c : LocationTableEntryMode.Percentage, sourceCurrencyCode: (_f = (_e = (_d = groupData.sourceCurrencyCode) !== null && _d !== void 0 ? _d : groupData.currencyCode) !== null && _e !== void 0 ? _e : queueData.data.currencyCode) !== null && _f !== void 0 ? _f : CurrencyCode.Dollar }), shrinkages), (isLocated ? {} : supportStaff)), { volumes: volumes, multiplier: stringToNumber(queueData.data.multiplier), trainWeeks: stringToNumber(queueData.data.trainWeeks.toString()) }), (isLocated
                ? { locations: groupLocations, queueLocations: groupLocations }
                : { locations: [], queueLocations: [] })));
        }
    }, [activeGroup, activeMemberIds, activeMemberQueueMap, multiSkillGroups, queueData.data, reset]);
    var handleFormSubmit = handleSubmit(function (data) {
        var hasInvalidGroup = multiSkillGroups.some(function (group) {
            if (group.children.length < 2)
                return false;
            var members = group.children.map(function (childId) { return allMemberQueueMap[childId]; });
            if (members.some(function (member) { return !member; }))
                return true;
            return !commonFootprint(members).valid;
        });
        if (hasInvalidGroup)
            return;
        var newData = __spreadArray([], multiSkillGroups, true);
        newData[activeGroup] = data;
        fetchMultiskillData({ items: newData.map(buildMultiskillPayload) });
    });
    var setGroupValues = function (values) {
        var _a, _b;
        var rawLocs = (_b = (_a = values.queueLocations) !== null && _a !== void 0 ? _a : values.locations) !== null && _b !== void 0 ? _b : [];
        var updatedQueueLocations = rawLocs.map(function (loc, idx) {
            var _a, _b, _c, _d;
            var locAlt = (_a = values.locations) === null || _a === void 0 ? void 0 : _a[idx];
            var qLoc = (_b = values.queueLocations) === null || _b === void 0 ? void 0 : _b[idx];
            return __assign(__assign({}, loc), { currencyCode: (_d = (_c = qLoc === null || qLoc === void 0 ? void 0 : qLoc.currencyCode) !== null && _c !== void 0 ? _c : locAlt === null || locAlt === void 0 ? void 0 : locAlt.currencyCode) !== null && _d !== void 0 ? _d : loc.currencyCode });
        });
        var updatedValues = __assign(__assign({}, values), { _children: values.children, locations: updatedQueueLocations.length ? updatedQueueLocations : values.locations, queueLocations: updatedQueueLocations.length ? updatedQueueLocations : values.queueLocations });
        setMultiSkillGroups(multiSkillGroups.map(function (item, index) { return (index === activeGroup ? updatedValues : item); }));
    };
    var handleChangeActiveGroup = function (value) {
        return handleSubmit(function (values) {
            setActiveGroup(value);
            setGroupValues(values);
        })();
    };
    var handleModifyGroups = function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    values = getValues();
                    return [4 /*yield*/, validateForm.isValid(values)];
                case 1:
                    isValid = _a.sent();
                    if (isValid) {
                        setGroupValues(values);
                    }
                    goToStep(MultiSkillStep.Add);
                    return [2 /*return*/];
            }
        });
    }); };
    var goToReport = function () {
        navigate("/report/".concat(basePlanId));
    };
    return (_jsxs(Box, __assign({ my: 6, gap: 4, component: "form", onSubmit: permission ? handleFormSubmit : goToReport }, { children: [_jsxs(Grid, __assign({ container: true, direction: "row", gap: 8, wrap: "nowrap" }, { children: [_jsx(Grid, __assign({ item: true, xs: 3, lg: 3 }, { children: _jsx(MultiSkillGroups, { data: multiSkillGroups, value: activeGroup, onChange: handleChangeActiveGroup, onModify: handleModifyGroups }) })), _jsxs(Grid, __assign({ item: true, xs: 9 }, { children: [_jsx(ErrorMessageBox, { errors: [multiskillData.error, simulationData.error] }), _jsxs(Stack, __assign({ direction: "row", gap: 2, mb: 5, alignItems: "center" }, { children: [_jsx(Typography, __assign({ variant: "h2" }, { children: _jsx(RumEntityLabel, __assign({ kind: "multiskillGroup", id: (_b = multiSkillGroups[activeGroup]) === null || _b === void 0 ? void 0 : _b.id }, { children: (_c = multiSkillGroups[activeGroup]) === null || _c === void 0 ? void 0 : _c.businessArea })) })), _jsx(Actions, { mt: 0, loading: isActionLoading })] })), _jsx(FormProvider, __assign({}, methods, { children: _jsx(FormlessProvider, __assign({ control: control, setValue: setValue }, { children: _jsx(WizardSimpleProvider, __assign({ plan: planData.data, queue: queue }, { children: _jsx(FallbackComponent, __assign({ requesting: !!queueData.requesting }, { children: _jsx(MultiskillLocationsProvider, __assign({ locations: (_e = (_d = formValues.locations) !== null && _d !== void 0 ? _d : formValues.queueLocations) !== null && _e !== void 0 ? _e : [], learningCurve100: allMembersLearningCurve100 }, { children: _jsx(MultiSkillGroupDetail, { activeData: formValues, permission: permission }) })) })) })) })) }))] }))] })), _jsx(Actions, { loading: isActionLoading })] })));
};
